import React, { useEffect, useMemo, useRef, useState } from 'react';

import { createPlatform } from './platform';
import { umrOverrideCss, umrOverrides } from './umrOverrides';

const applyCss = (id, css) => {
    if (!css || typeof document === 'undefined') return;
    const styleId = 'umr-part-css-' + id;
    let node = document.getElementById(styleId);
    if (!node) {
        node = document.createElement('style');
        node.id = styleId;
        document.head.appendChild(node);
    }
    node.textContent = css;
};

const renderDefault = (children, props, platform) => {
    if (!React.isValidElement(children)) return children || null;
    return React.cloneElement(children, { ...(props || {}), platform });
};

export const PartSlot = ({ id, props, children }) => {
    const [drawerCart, setDrawerCart] = useState(null);
    const propsRef = useRef(props);
    propsRef.current = props;
    const platform = useMemo(() => createPlatform(
        (cart) => setDrawerCart(cart),
        () => propsRef.current,
    ), []);
    const Override = id ? umrOverrides[id] : null;

    useEffect(() => {
        if (Override && umrOverrideCss[id]) applyCss(id, umrOverrideCss[id]);
    }, [Override, id]);

    const body = Override
        ? React.createElement(Override, { ...(props || {}), platform })
        : renderDefault(children, props, platform);

    const CartDrawer = platform.ui.CartDrawer;
    return React.createElement(React.Fragment, null,
        body,
        React.createElement(CartDrawer, {
            open: Boolean(drawerCart),
            cart: drawerCart && drawerCart !== true ? drawerCart : null,
            onClose: () => setDrawerCart(null),
        }),
    );
};
